import * as React from 'react';
import { Box, type BoxProps, styled } from '@mui/material'
import type { ComponentType } from 'react'

type ConversationPanelHandleProps = BoxProps

export const ConversationPanelHandle = styled(Box, {
  slot: 'ConversationPanelHandle-Handle',
})<ConversationPanelHandleProps>(
  ({
    theme: {
      zIndex,
      vars: { palette },
    },
  }) => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: zIndex.tooltip,

    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: palette.grey[300],
      transition: 'background-color 500ms linear',
    },
  }),
) as ComponentType<ConversationPanelHandleProps>
